import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

import { Form, Col, Row, FormControl } from "react-bootstrap";

import { toast } from "react-toastify";

import UserService from "../../services/user.service";

function Modaladduser(props) {
  const handleClose = () => {
    initialForm();
    props.hidden(false);
  };
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const [image, setImage] = useState({ preview: "", raw: "" });
  const [ocsb, setOcsb] = useState([]);
  const [academy, setAcademy] = useState([]);
  const [factory, setFactory] = useState([]);
  const [region, setRegion] = useState([]);
  const [listRoles, setListRoles] = useState([]);

  //   const [acceptedTerms, setAcceptedTerms] = useState(false);

  useEffect(() => {
    UserService.listRoles()
      .then((response) => {
        setListRoles(response.data.data);
      })
      .catch((error) => console.log(error));
    UserService.getOcsb()
      .then((response) => {
        setOcsb(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getOcsb: ", error);
      });
    UserService.getAcademylist()
      .then((response) => {
        setAcademy(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getAcademy: ", error);
      });
    UserService.getFactorylist()
      .then((response) => {
        setFactory(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
    UserService.getRegionlist()
      .then((response) => {
        setRegion(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
  }, []);
  const initialForm = () => {
    setForm({});
    setErrors({});
    setImage({ preview: "", raw: "" });
  };
  const setField = (field, value) => {
    if (field.files) {
      if (field.name === "ca_file") {
        console.log(field.name);
        setForm({
          ...form,
          [field.name]: field.files[0],
        });
      } else {
        setImage({
          preview: URL.createObjectURL(field.files[0]),
        });
        setForm({
          ...form,
          [field.name]: field.files[0],
        });
      }
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const findFormErrors = () => {
    const {
      member_type,
      registerEmail,
      registerUsername,
      registerPassword,
      conPassword,
      user_reg,
      academy,
      titlename,
      position,
      registerFname,
      registerLname,
    } = form;
    const newErrors = {};

    // member_type errors
    if (!registerFname || registerFname === "")
      newErrors.registerFname = "กรุณากรอกชื่อ";

    // member_type errors
    if (!registerLname || registerLname === "")
      newErrors.registerLname = "กรุณากรอกนามสกุล";
    // member_type errors
    if (!member_type || member_type === "0")
      newErrors.member_type = "กรุณาเลือกข้อมูล";

    // titlename errors
    if (!titlename || titlename === "")
      newErrors.titlename = "กรุณากรอกคำนำหน้าชื่อ";

    // position errors
    if (!position || position === "") newErrors.position = "กรุณากรอกตำแหน่ง";

    // check select user_reg;
    if (
      (member_type === "2" || member_type === "3") &&
      (!user_reg || user_reg === "0")
    )
      newErrors.user_reg = "กรุณาเลือกข้อมูล";

    // Check select assoc
    if (member_type === "4" && (!academy || academy === "0"))
      newErrors.academy = "กรุณาเลือกข้อมูล";

    // registerEmail errors
    if (!registerEmail || registerEmail === "")
      newErrors.registerEmail = "กรุณากรอก Email";

    // registerUsername errors
    if (!registerUsername || registerUsername === "")
      newErrors.registerUsername = "กรุณากรอก Username";
    else if (registerUsername.length < 4)
      newErrors.registerUsername = "Username ต้องมากกว่า 5 ตัว";

    // registerPassword errors
    if (!registerPassword || registerPassword === "")
      newErrors.registerPassword = "กรุณากรอก Password";
    else if (registerPassword.length < 6)
      newErrors.registerPassword = "Password ต้องมากกว่า 6 ตัวอักษร";

    // conPassword errors
    if (!conPassword || conPassword === "")
      newErrors.conPassword = "กรุณากรอกยืนยัน Password";
    else if (conPassword != registerPassword)
      newErrors.conPassword = "ยืนยัน Password ไม่ถูกต้อง";

    // // comment errors
    // if (!comment || comment === "") newErrors.comment = "cannot be blank!";
    // else if (comment.length > 100) newErrors.comment = "comment is too long!";

    return newErrors;
  };

  const handleSubmit = (e) => {
    const data = new FormData();
    for (const key in form) {
      data.append(key, form[key]);
    }
    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      // alert("Thank you for your feedback!");
      // console.log(form);
      UserService.createUser(data)
        .then((response) => {
          if (response.data.success) {
            // window.location.reload(true);
            // const rows = props.data.push(response.data.user);
            // props.addData(rows);
            props.setdata([response.data.user, ...props.data]);
            // setUserlist([...newArray]);
            initialForm();
            props.hidden(false);
            toast.success("บันทึกข้อมูลเรียบร้อย");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          // console.error("error fetching data: ", error);
          toast.error(error);
          console.log(error);
        })
        .finally(() => {
          console.log(false);
        });
    }
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มผู้ใช้งาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="uploadpic">
            <label htmlFor="upload-button">
              {image.preview ? (
                <img src={image.preview} alt="dummy" width="150" height="150" />
              ) : (
                <>
                  <span className="fa-stack fa-2x mt-3 mb-2">
                    <i className="fas fa-circle fa-stack-2x" />
                    <i className="fas fa-store fa-stack-1x fa-inverse" />
                  </span>
                  <h5 className="text-center">Upload your photo</h5>
                </>
              )}
            </label>
            <input
              type="file"
              id="upload-button"
              name="registerProfileImg"
              style={{ display: "none" }}
              onChange={(e) => setField(e.target, e.target.value)}
            />
            <br />
            {/* <Button variant="primary" type="button" onClick={handleUpload}>
            อัพโหลด
          </Button> */}
          </div>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>ประเภทผู้ใช้งาน</Form.Label>
                  <Form.Select
                    name="member_type"
                    value={form.member_type}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.member_type}
                  >
                    <option value="0">เลือกประเภทผู้ใช้งาน</option>
                    {listRoles.map((item, key) => {
                      return (
                        <option key={key} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                    {/* <option value="1">ผู้ดูแลระบบ</option>
                    <option value="2">เจ้าหน้าที่จดทะเบียน</option>
                    <option value="3">นายทะเบียน</option>
                    <option value="4">เจ้าหน้าที่สมาคม</option>
                    <option value="5">เจ้าหน้าที่ สอน.</option>
                    <option value="6">เจ้าหน้าที่ สอน.2</option>
                    <option value="7">เจ้าหน้าที่ โรงงาน</option> */}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.member_type}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>เขต</Form.Label>
                  <Form.Select
                    name="user_reg"
                    value={form.user_reg}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.user_reg}
                  >
                    <option value="">เลือกเขต</option>
                    {region.map((o) => (
                      <option key={o.region_id} value={o.region_code}>
                        {o.region_name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.user_reg}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>สอน.</Form.Label>
                  <Form.Select
                    name="ocsb"
                    value={form.ocsb}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.ocsb}
                  >
                    <option value="">เลือกหน่วยงาน สอน.</option>
                    {ocsb.map((o) => (
                      <option key={o.ocsbId} value={o.ocsbId}>
                        {o.ocsbName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.ocsb}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>สถาบัน</Form.Label>
                  <Form.Select
                    name="academy"
                    value={form.academy}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.academy}
                  >
                    <option value="">เลือกสถาบัน</option>
                    {academy.map((o) => (
                      <option key={o.academyId} value={o.academyId}>
                        {o.academyName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.academy}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โรงงาน</Form.Label>
                  <Form.Select
                    name="factory"
                    value={form.factory}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factory}
                  >
                    <option value="">เลือกโรงงาน</option>
                    {factory.map((o) => (
                      <option key={o.factoryId} value={o.factoryId}>
                        {o.factoryName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factory}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อผู้ใช้งาน</Form.Label>
                  <FormControl
                    placeholder="กรอกชื่อผู้ใช้งาน"
                    name="registerUsername"
                    value={form.registerUsername}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerUsername}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerUsername}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อีเมลล์</Form.Label>
                  <FormControl
                    placeholder="กรอกอีเมลล์"
                    type="email"
                    name="registerEmail"
                    value={form.registerEmail}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="2">
                <Form.Group className="mb-2">
                  <Form.Label>คำนำหน้าชื่อ</Form.Label>
                  <FormControl
                    placeholder="คำนำหน้าชื่อ"
                    name="titlename"
                    value={form.titlename}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.titlename}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.titlename}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="5">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อ"
                    name="registerFname"
                    value={form.registerFname}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerFname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerFname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="5">
                <Form.Group className="mb-2">
                  <Form.Label>นามสกุล</Form.Label>
                  <FormControl
                    placeholder="นามสกุล"
                    name="registerLname"
                    value={form.registerLname}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerLname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerLname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col md="12">
                {" "}
                <Form.Group className="mb-2">
                  <Form.Label>ตำแหน่ง</Form.Label>
                  <FormControl
                    placeholder="ตำแหน่ง"
                    name="position"
                    value={form.position}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.position}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.position ? errors.position : ""}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col md="12">
                <Form.Group className="mb-3">
                  <Form.Label>CA ไฟล์</Form.Label>
                  <Form.Control
                    type="file"
                    label="เลือกไฟล์"
                    name="ca_file"
                    onChange={(e) => setField(e.target, e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>รหัสผ่าน</Form.Label>
                  <FormControl
                    placeholder="รหัสผ่าน"
                    name="registerPassword"
                    type="password"
                    autocomplete="off"
                    value={form.registerPassword}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerPassword}
                  />{" "}
                  <Form.Control.Feedback type="invalid">
                    {errors.registerPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ยืนยันรหัสผ่าน</Form.Label>
                  <FormControl
                    placeholder="ยืนยันรหัสผ่าน"
                    type="password"
                    name="conPassword"
                    autocomplete="off"
                    value={form.conPassword}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.conPassword}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.conPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Modaladduser;

Modaladduser.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
};
